"use strict";

var _require = require('./Component'),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.online/httpdocs/~/react-copy-to-clipboard/lib/index.js
// module id = 187
// module chunks = 0